import { CommonModule } from '@angular/common'
import { Component, OnDestroy, AfterViewInit } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { Subscription } from 'rxjs'
import { EventService } from '../../services/event.service'
import { RouterPage, RouterService } from '../../services/router.service'

@Component({
  selector: 'app-base-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './base-layout.component.html',
  styleUrls: ['./base-layout.component.scss'],
})
export class BaseLayoutComponent implements OnDestroy, AfterViewInit {
  eventSubscription?: Subscription

  constructor(
    private eventService: EventService,
    private routerService: RouterService
  ) {
    // do nothing
  }

  ngAfterViewInit(): void {
    this.registerEventListener()
  }

  ngOnDestroy(): void {
    this.eventSubscription?.unsubscribe()
  }

  registerEventListener(): void {
    this.eventSubscription = this.eventService.keyDown.subscribe((key: string) => {
      switch (key) {
        case 'BACK':
          // TODO: Exception for Channel page since we cannot garante it is not below BaseLayout now...
          if (this.routerService.isCurrentPage(RouterPage.CHANNEL)) {
            return
          }
          this.routerService.goBack()
          break
        default:
          break
      }
    })
  }
}
